import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountAccountsInfoComponent = ({ 
  onInnerFormChange, typeId, selectedAccounts, industryType, businessType, 
  accountSource, operatingHours, accounts, organizationUnits, accountType , selectMappedAccountTypes
}: any) => {
  
  return(
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Business Name"
            name="Name"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.Name',
                selectedAccounts?.AccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.AccountInfo?.Name}
          />
          <InputContainer
            label="Business Type"
            labelField="Text"
            list={businessType}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.BusinessTypeId',
                selectedAccounts?.AccountInfo
              );
            }}
            optionName='Choose BusinessType'
            type="select"
            value={selectedAccounts?.AccountInfo?.BusinessTypeId}
            valueField="Value"
          />
          <InputContainer
            label="Industry Type"
            labelField="Text"
            list={industryType}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.IndustryTypeId',
                selectedAccounts?.AccountInfo
              );
            }}
            optionName='Choose IndustryType'
            type="select"
            value={selectedAccounts?.AccountInfo?.IndustryTypeId}
            valueField="Value"
          />
          <InputContainer
            label="Account Source"
            labelField="Text"
            list={accountSource}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.AccountSourceId',
                selectedAccounts?.AccountInfo
              );
            }}
            optionName='Choose AccountSource'
            type="select"
            value={selectedAccounts?.AccountInfo?.AccountSourceId}
            valueField="Value"
          />
          <InputContainer
            label="Annual Revenue"
            name="AnnualRevenue"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.AnnualRevenue',
                selectedAccounts?.AccountInfo
              )
            }}
            type="number"
            value={selectedAccounts?.AccountInfo?.AnnualRevenue}
          />
          <InputContainer
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.Description',
                selectedAccounts?.AccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.AccountInfo?.Description}
          />
          <InputContainer
            label="Operating Hours"
            labelField="Description"
            list={operatingHours}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.OperatingHoursId',
                selectedAccounts?.AccountInfo
              );
            }}
            optionName='Choose OperatingHours'
            type="select"
            value={selectedAccounts?.AccountInfo?.OperatingHoursId}
            valueField="Value"
          />
          <InputContainer
            label="Parent Account"
            labelField="Name"
            list={accounts}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.ParentId',
                selectedAccounts?.AccountInfo
              );
            }}
            optionName='Choose ParentAccount'
            type="select"
            value={selectedAccounts?.AccountInfo?.ParentId}
            valueField="Id"
          />
          
          <InputContainer
            label="Type"
            labelField="Text"
            list={typeId}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.TypeId',
                selectedAccounts?.AccountInfo
              );
            }}
            optionName='Choose Type Id'
            type="select"
            value={selectedAccounts?.AccountInfo?.TypeId}
            valueField="Value"
          />
          <InputContainer
            label="Website"
            name="Website"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.Website',
                selectedAccounts?.AccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.AccountInfo?.Website}
          />
          <InputContainer
            label="Year Started"
            name="YearStarted"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.YearStarted',
                selectedAccounts?.AccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.AccountInfo?.YearStarted}
          />
          <InputContainer
            label="FSSAI License Number"
            name="FSSAI_License_Number"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.FSSAI_License_Number',
                selectedAccounts?.AccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.AccountInfo?.FSSAI_License_Number}
          />
          <InputContainer
            label="Display Name"
            name="DisplayName"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'AccountInfo.DisplayName',
                selectedAccounts?.AccountInfo
              )
            }}
            type="text"
            value={selectedAccounts?.AccountInfo?.DisplayName}
          />
          <InputContainer

            label="PersonAccount"
            name="IsPersonAccount"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.IsPersonAccount',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.IsPersonAccount}
          />
          <InputContainer

            label="Customer Portal Enabled"
            name="IsCustomerPortalEnabled"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.IsCustomerPortalEnabled',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.IsCustomerPortalEnabled}
          />
          <InputContainer

            label="Vendor Portal Enabled"
            name="IsVendorPortalEnabled"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.IsVendorPortalEnabled',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.IsVendorPortalEnabled}
          />
          <InputContainer

            label="Guest Access Enabled"
            name="IsGuestAccessEnabled"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.IsGuestAccessEnabled',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.IsGuestAccessEnabled}
          />
          <InputContainer

            label="Enable On Network Logistics Support"
            name="EnableOnNetworkLogisticsSupport"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.EnableOnNetworkLogisticsSupport',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.EnableOnNetworkLogisticsSupport}
          />
          <InputContainer

            label="Partner Enabled"
            name="IsPartnerEnabled"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.IsPartnerEnabled',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.IsPartnerEnabled}
          />
          <InputContainer

            label="Account Verified"
            name="IsAccountVerified"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.IsAccountVerified',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.IsAccountVerified}
          />
          <InputContainer

            label="Limited To OrganizationUnit"
            name="IsLimitedToOrganizationUnit"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'AccountInfo.IsLimitedToOrganizationUnit',
                selectedAccounts?.AccountInfo
              )
            }}
            type="checkbox"
            value={selectedAccounts?.AccountInfo?.IsLimitedToOrganizationUnit}
          />
        </div>
      }

      expandedPanel="Account Information"
      headerTitle="Account Information"
    />
    {selectedAccounts?.AccountInfo?.IsLimitedToOrganizationUnit
      ? <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Limited To OrganizationUnit"
              labelField="Name"
              list={organizationUnits}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value || '')
                onInnerFormChange(
                  valueData,
                  'LimitedToOrganizationUnitMappings.LimitedToOrganizationUnitIds',
                  selectedAccounts?.LimitedToOrganizationUnitMappings
                );
              }}
              type="multiselect"
              valueField="Id"
              value={selectedAccounts?.LimitedToOrganizationUnitMappings?.LimitedToOrganizationUnitIds}
            />

          </div>
        }
        expandedPanel="LimitedToOrganizationUnitMappings"
        headerTitle="LimitedToOrganizationUnitMappings"
      />
      : null}
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Account Type"
            labelField="Name"
            list={accountType}
            onValueChange={(newValue: any) => {
              const valueData: any = newValue.map((option: any) => option?.value || '')
              onInnerFormChange(
                valueData,
                'MappedAccountTypes.MappedAccountTypeIds',
                selectMappedAccountTypes?.MappedAccountTypes
              );
            }}
            type="multiselect"
            valueField="Id"
            value={selectMappedAccountTypes?.MappedAccountTypes?.MappedAccountTypeIds}
          />

        </div>
      }
      expandedPanel="Mapped Account Types"
      headerTitle="Mapped Account Types"
    />
  </>
)
}
export default AccountAccountsInfoComponent;
